import BaseError from "./BaseError";

export default class NotFoundError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "NotFoundError";
  }
}
